import { TranslateDto } from "../translate.dto";

export const it: TranslateDto = {
  // Not found Page
  Not_found_page: "404: Pagina non trovata.",
  //Global
  Go_back: "Torna all'inizio",
  // Topbar
  Slogan: "L'unico occhiale completamente personalizzabile al 100%",
  // PutPostCode
  Error_PERMISSION_DENIED:
    "L'unico occhiale completamente personalizzabile al 100%.",
  Error_POSITION_UNAVAILABLE:
    "Le informazioni sulla posizione non sono disponibili.",
  Error_TIMEOUT: "Il tempo di richiesta è scaduto",
  Error_UNKNOWN_ERROR: "Si è verificato un errore sconosciuto.",
  Error_default: "Si è verificato un errore sconosciuto.",
  Search_your_optic: "Cerca il tuo ottico più vicino.",
  Description_for_search_optic:
    "Inserisci il tuo codice postale e cercheremo gli ottici più vicini a te. 👇.",
  Alert: "Sembra che ci sia un problema.",
  Placeholder_search_optic: "Inserisci il tuo indirizzo o il codice postale",
  Can_I_Have_Your_Ubication: "Posso avere la tua posizione?",
  Description_We_Need_Ubication:
    "Per trovare l'ottico più vicino a te, dovrai permettermi di accedere alla tua posizione.",
  Confirm: "Sì, certo!",
  Denaied: "No, grazie",
  Cant_Accesses_Your_Ubication:
    "Mi dispiace, non posso accedere alla tua posizione.",
  Description_Cant_Accesses_Your_Ubication:
    "Sembra che tu abbia negato l'accesso alla tua posizione. Per trovare l'ottico più vicino a te, dovrai inserire il tuo indirizzo o il codice postale nel campo sopra",
  Accept: "D'accordo",
  Search_GPS: "Ricerca GPS...",
  Use_My_Location: "Usa la mia posizione attuale",
  No_Selection_Location: "Non hai selezionato alcun indirizzo",
  Search: "Cerca",
  Ofert1: "Approfitta del -15% di sconto + regalo a sorpresa per un tempo limitato",
  // Ubication
  Go_to_the_list: "Torna alla lista",
  This_is_your_optics: "Questi sono i tuoi ottici più vicini:",
  Description_We_Need_Ubication2:
    "Inserisci il tuo indirizzo nel campo di ricerca in alto per trovare l'ottico più vicino a te",
  Not_Found_Optics: "Ops...! Non ci sono ottici vicino a te.",
  Form_to_contact: "Puoi anche consultare con noi per",
  Distance: " Chilometri di distanza",
  Ask_date: "PRENOTA UN APPUNTAMENTO.",
  // CardOptic
  Optic_nearest: "Questo è il tuo punto vendita più vicino.",
  Of_distance: " di distanza",
  See_map: "Visualizza mappa",
  // Schedule
  Ofert2:
    "Prenota un appuntamento e ottieni uno sconto del 15% e un esame della vista gratuito!",
  PostCode_banner_promo:
    "Prenota un appuntamento e ottieni uno sconto e un esame della vista gratuito!",
  Choose_optic: "Ottica scelta:",
  Direction: "Indirizzo:",
  Selected_day: "Seleziona un giorno:",
  Schedule_subtitle: "Clicca sull'ora del giorno in cui desideri provare i tuoi FLiPO senza impegno e con esame della vista gratuito",
  Choose_hour: "Scegli un orario per essere assistito:",
  Load_more_days: "Mostra più giorni",
  No_search_schedules: "Ops...! Non ci sono appuntamenti disponibili.",
  Change_optic: "Cambiare ottico.",
  See_more: "Vedi di più",
  Try_another_week: "Puoi anche provare un'altra settimana",
  // Hours Container
  No_schedule: "Non ci sono più prenotazioni disponibili",
  // Client Data
  Form_title: "Inserisci i tuoi dati per prenotare l'appuntamento",
  Receive_ofert: "Riceverai la tua offerta via e-mail o WhatsApp",
  Your_choose_optic: "La tua ottica scelta:",
  Your_choose_date: "La tua data scelta:",
  Name: "Nome",
  Subname: "Cognome",
  Phone: "Telefono",
  Email: "Email",
  Incorrect_field: "Campo errato *",
  Next: "Successivo",
  // Confirmation
  Error_create_appointment:
    "Si è verificato un errore durante la creazione dell'appuntamento",
  Error_update_appointment:
    "Si è verificato un errore durante l'aggiornamento dell'appuntamento.",
  Error_active_appointment_title: "Hai già un appuntamento attivo",
  Error_active_appointment_desc:
    "Non puoi prenotare un altro appuntamento mentre ne hai uno attivo in sospeso. Se devi modificarlo, contatta la tua ottica o modificalo dall'email che hai ricevuto al momento della prenotazione.",
  Edit_your_data: "Modifica i tuoi dati per cambiare l'appuntamento.",
  Confirm_for_reserve: "Appuntamento confermato con successo",
  Change_my_optic: "Cambia la mia ottica",
  Change_my_date: "cambia la mia data",
  changeMyData: "cambia i miei dati",
  Your_data: "I tuoi dati di contatto:",
  Confirm_appointment: "Conferma appuntamento.",
  Edit_my_data: "Modifica i miei dati.",
  Greetings: "Ciao!",
  Of: "de",
  Await_you: "ti aspetterà il giorno.",
  At: "alle",
  If_put: "Se indossi le lenti a contatto.",
  No_24h: "non metterle per 24 ore.",
  Pre_exam: "prima dell'esame",
  Is_easy: "È molto facile arrivare a:",
  Benefit_appointment_title: "Durante l'appuntamento:",
  Benefit_appointment_1: "Effettuiamo una revisione completamente gratuita.",
  Benefit_appointment_2:
    "Potrai provare una vasta selezione di colori e accessori.",
  Benefit_appointment_3:
    "Verificherai quali dei nostri modelli si adattano meglio al tuo viso",
  Benefit_appointment_4:
    "Potrai consultare con il tuo ottico quali clips hai bisogno.",
  Free: "Tutto in modo gratuito!",
  Remember:
    "Ricorda che con il tuo appuntamento prenotato non dovrai fare la fila, inoltre, solo per partecipare",
  Promotion: "potrai godere del 15% di sconto e del regalo sorpresa",
  No_assist:
    "In caso non potessi partecipare o avessi qualsiasi dubbio, puoi contattarci tramite",
  Or: "o",
  Start: "Inizio",
  Until_the: "Fino a quando",
  // Landing Page
  Landing_header: "SCOPRI LA NOSTRA COLLEZIONE DI ACCESSORI",
  Landing_hero_banner_title_1: "PRENOTA E",
  Landing_hero_banner_title_2: "OTTIENI I TUOI FLiPO",
  Landing_hero_banner_subtitle: "ESAME GRATUITO E IN POCHI MINUTI",
  Landing_hero_title_1: "IL TUO ESAME VISIVO, ",
  Landing_hero_title_2: "GRATUITO",
  Landing_hero_title_3: "E IN MINUTI",
  Landing_form_subtitle: "Sei a un clic dal scoprire gli",
  Landing_form_subtitle_highlight: "occhiali modulari che cambiano con te",
  Landing_form_name_label: "Nome*",
  Landing_form_phone_label: "Telefono*",
  Landing_form_lastname_label: "Cognome*",
  Landing_form_email_label: "Email*",
  Landing_form_postcode_label: "Codice postale*",
  Landing_form_postcode_placeholder: "Cerca il tuo indirizzo o codice postale",
  Landing_form_button: "PRENOTA IL TUO APPUNTAMENTO GRATUITO",
  Landing_form_no_thanks: "Non voglio gradurare i miei occhiali",
  Landing_form_disclaimer: "*I tuoi dati saranno utilizzati solo per coordinare l'appuntamento. Non condivideremo mai informazioni.",
  Landing_glasses_title_1: "ADATTA I TUOI FLiPO",
  Landing_glasses_title_2: "A QUALSIASI MOMENTO DELLA GIORNATA",
  Landing_glasses_solar_title: "Protezione Solare",
  Landing_glasses_solar_desc: "Lente polarizzata US10 con UV400 per ridurre l'abbagliamento. Proteggiti dall'esposizione solare.",
  Landing_glasses_dreamred_title: "DreamRed",
  Landing_glasses_dreamred_desc: "Lente di riposo. Le lenti rosse bloccano il 100% della luce blu e il 60% della luce verde, favorendo la produzione naturale di luce.",
  Landing_glasses_screen_title: "Protezione Schermo",
  Landing_glasses_screen_desc: "Riduce i riflessi, ti mantiene chiaro e migliora il contrasto tra schermo e ambiente. Aumenta contro la luce blu.",
  Landing_glasses_night_title: "Guida notturna",
  Landing_glasses_night_desc: "Lente polarizzata V75 Enhanced con UV400 che permette una visione senza riflessi, riducendo l'abbagliamento.",
  Landing_color_banner_title: "AGGIUNGI COLORE E STILE AI TUOI OCCHIALI",
  Landing_color_banner_text: "Cambia clip e stanghette perché i tuoi occhiali si abbinino al tuo outfit, al tuo umore o all'occasione.",
  Landing_color_banner_button: "PRENOTA IL TUO APPUNTAMENTO",
  Landing_final_banner_title_1: "E tu,",
  Landing_final_banner_title_2: "quale FLiPO scegli?",
  Landing_newsletter_title: "Iscriviti alla nostra Newsletter",
  Landing_newsletter_subtitle: "Scopri tutte le nostre offerte e novità",
  Landing_newsletter_email_placeholder: "Indirizzo email",
  Landing_newsletter_checkbox: "Ho letto e accetto la Politica sulla Privacy e i Termini e Condizioni",
  Landing_newsletter_country_label: "Paese/regione",
  Landing_social_title: "Seguici sui nostri social",
  Landing_footer_plan: "Piano di abbonamento",
  Landing_footer_faqs: "FAQ",
  Landing_footer_shipping: "Spedizioni e Resi",
  Landing_footer_payment: "Metodo di Pagamento",
  Landing_footer_gift: "Carte Regalo",
  Landing_footer_contact: "Contatto",
  Landing_footer_jobs: "Lavora con noi",
  Landing_copyright: "© Copyright 2025. FLiPO.",
  Landing_copyright_rights: "Tutti i diritti riservati.",
  Landing_privacy: "Politica sulla privacy e cookie",
  Landing_shipping_policy: "Politica di spedizione",
  Landing_terms: "Termini e condizioni",
  Landing_contact_info: "Informazioni di contatto",
  Landing_legal_notice: "Avviso legale",
  // Loading & Error screens
  Loading_searching_optic: "Cerchiamo la tua ottica...",
  Loading_moment: "Ci vorrà solo un momento",
  Creating_appointment: "Stiamo creando il tuo appuntamento...",
  Error_optic_not_found: "Ottica non trovata",
  Error_optic_not_found_desc: "Non siamo riusciti a trovare l'ottica con il codice fornito. Per favore, verifica il link o cerca un'ottica vicina.",
  Error_network: "Errore di connessione",
  Error_network_desc: "Non siamo riusciti a connetterci al server. Per favore, verifica la tua connessione internet e riprova.",
  Error_unknown: "Qualcosa è andato storto",
  Error_unknown_desc: "Si è verificato un errore imprevisto. Per favore, riprova o cerca un'ottica vicina.",
  Error_search_nearby: "Cerca ottica vicina",
  Error_retry: "Riprova",
  Error_go_home: "Vai all'inizio",
  // FAQs
  Question_1: "Di cosa sono fatti gli occhiali FLiPO?",
  Answer_1:
    "Tutti i nostri prodotti sono realizzati con un materiale all'avanguardia per flessibilità e resistenza, noto come ULTEM. Per maggiori informazioni è possibile consultare la scheda tecnica di ogni modello di occhiali",
  Question_2: "Come funzionano le clip e le aste?",
  Answer_2:
    "Le clip e le aste funzionano grazie a un sistema magnetico che le rende facili e sicure da applicare senza il timore che si stacchino.",
  Question_3:
    "Qual è la differenza tra la clip funzionale e la clip di design?",
  Answer_3:
    "La clip funzionale combina l'aiuto visivo delle lenti da vista e, grazie alle diverse funzionalità, trasforma gli occhiali e protegge dalla luce blu, dal sole e da altri raggi che possono compromettere la vista. La clip di design, invece, cambia l'aspetto del frontale della montatura e, insieme alla sostituzione delle aste, cambia completamente lo stile degli occhiali",
  Question_4: "Quando saranno pronti i miei occhiali monofocali FLiPO?",
  Answer_4: "I vostri occhiali saranno pronti in 7-10 giorni lavorativi",
  Question_5: "Quando saranno pronti i miei occhiali progressivi FLiPO?",
  Answer_5:
    "I vostri occhiali saranno pronti in 7-10 giorni lavorativi - vale la pena aspettare!",
};
